import React, { useContext, useState } from 'react'
import fetch from 'cross-fetch'
import { Grid, GridCell, Spacer, Text, View } from 'oio-react'
import { Link } from 'react-router-dom'
import { SearchIcon } from 'assets/icons'
import { initiativeUrl } from 'config/constants/urls'
import SearchListItemRow from 'src/apps/Search/components/ListItemRow'
import { useSearchInitiatives } from 'src/graphql/hooks'
import ThemeContext from 'src/libraries/contexts/Theme'
import AlgoliaSearchResultListItem from './AlgoliaSearchResultListItem'

const algoliaAppId = 'RM22375DTG'
const algoliaApiKey = '6d6ea1a0fd210184b95ba9a589e11b17'
const algoliaApiUrl = `https://${algoliaAppId}-dsn.algolia.net/1/indexes/*/queries`

const Search = () => {
   const [activeSearchValue, setActiveSearchValue] = useState('')
   const [algoliaSearchResults, setAlgoliaSearchResults] = useState([])
   const theme = useContext(ThemeContext)

   const { searchInitiatives: searchResults, loading } = useSearchInitiatives({
      search: activeSearchValue
   }, {
      // TODO: Skip is currently not respected
      // See: https://github.com/apollographql/apollo-client/issues/6190
      skip: activeSearchValue === ''
   })

   const searchAlgolia = async (searchValue) => {
      const payload = {
         requests: [{
            indexName: 'gns3',
            query: searchValue
         }]
      }

      const response = await fetch(algoliaApiUrl, {
         method: 'POST',
         headers: {
            'X-Algolia-Application-Id': algoliaAppId,
            'X-Algolia-API-Key': algoliaApiKey
         },
         body: JSON.stringify(payload)
      })

      const result = await response.json()
      setAlgoliaSearchResults(result.results[0].hits)
   }

   const handleKeyUp = (event) => {
      if (event.key === 'Enter') {
         const searchValue = event.currentTarget.value.trim()
         event.preventDefault()
         setActiveSearchValue(searchValue)
         searchAlgolia(searchValue)
      }
   }

   return (
      <View width="100%">
         <View
            paddingLeft={theme.viewportMarginLeft}
            paddingRight={theme.viewportMarginRight}
            paddingBottom="50px"
            width="100%"
            minHeight="100vh"
            backgroundColor="#eee">
            <View
               display="flex"
               justifyContent="center"
               width="100%"
               backgroundColor="#0e1624"
               marginBottom="30px">
               <View
                  width="100%"
                  maxWidth={theme.viewportContentMaxWidth}
                  paddingRight={theme.viewportPaddingRight}
                  paddingLeft={theme.viewportPaddingLeft}>
                  <View width="100%">
                     <View
                        display="flex"
                        alignItems="center"
                        width="100%"
                        height="40px[a-b] 70px[c-f]"
                        padding="0px 20px[a-b] 0px 30px[c-f]"
                        margin="30px 0px[a-c] 50px 0px[d-f]"
                        backgroundColor="rgba(255,255,255,0.1)"
                        borderRadius="5px">
                        <View
                           display="flex"
                           alignItems="center"
                           flex="0 0 auto"
                           width="16px[a-b] 20px[c-f]"
                           height="16px[a-b] 20px[c-f]"
                           marginRight="20px">
                           <SearchIcon width="100%" height="100%" color="#eee" />
                        </View>
                        <View
                           display="flex"
                           alignItems="center"
                           flex="1 1 auto"
                           height="70px">
                           <input
                              id="searchInput"
                              onKeyUp={handleKeyUp}
                              type="text"
                              placeholder="Search"
                              style={{
                                 color: '#fff',
                                 fontSize: '22px',
                                 width: '100%',
                                 height: '100%',
                                 backgroundColor: 'transparent'
                              }}
                           />
                        </View>
                     </View>
                  </View>
               </View>
            </View>
            <View
               display="flex"
               justifyContent="center"
               width="100%">
               <View
                  width="100%"
                  maxWidth={theme.viewportContentMaxWidth}
                  paddingRight={theme.viewportPaddingRight}
                  paddingLeft={theme.viewportPaddingLeft}>
                  {!activeSearchValue && (
                     <View
                        backgroundColor="#fff"
                        borderRadius="5px"
                        width="100%"
                        padding="50px"
                        textAlign="center">
                        <Text size="2.5" color="#888">
                           Enter a search term to begin
                        </Text>
                     </View>
                  )}
                  <View
                     display={activeSearchValue ? 'block' : 'none'}
                     width="100%">
                     <Grid columns="1[a-c] 2[d-f]" spacing="20px[a-d] 30px[e-f]">
                        <GridCell>
                           <View
                              float="left"
                              width="100%"
                              padding="20px[a-d] 30px[e-f]"
                              backgroundColor="#fff"
                              borderRadius="5px"
                              minHeight="200px[a-c] 400px[d-f]"
                              border="1px solid #eee">
                              <Text size="3[a-d] 4[e-f]" weight="medium">
                                 GNS3 Documentation Results
                              </Text>
                              <Spacer size="6" />
                              {algoliaSearchResults.map((result) => {
                                 // Default Body
                                 let body = result._highlightResult?.hierarchy?.lvl0?.value

                                 // Best Body
                                 if (result._highlightResult?.content?.value) {
                                    body = result._highlightResult?.content?.value
                                 // Second-best Body
                                 } else if (result._highlightResult?.hierarchy?.lvl1?.value) {
                                    body = result._highlightResult?.hierarchy?.lvl1?.value
                                 }

                                 return (
                                    <AlgoliaSearchResultListItem
                                       key={result.objectID}
                                       body={body}
                                       category={result.hierarchy.lvl1 || result.hierarchy.lvl0}
                                       subtitle={result._highlightResult?.hierarchy?.lvl2?.value ||
                                          result._highlightResult?.hierarchy?.lvl1?.value}
                                       title={result._highlightResult?.hierarchy?.lvl0?.value ||
                                          result.hierarchy.lvl0}
                                       url={result.url}
                                    />
                                 )
                              })}
                              {algoliaSearchResults.length === 0 && (
                                 <View width="100%" padding="30px" textAlign="center">
                                    <Text size="2.5" color="#888">
                                       {'There were no results found for '}
                                       <Text
                                          size="2.5"
                                          color="#333"
                                          weight="medium"
                                          style={{
                                             display: 'inline-block'
                                          }}>
                                          {activeSearchValue}
                                       </Text>
                                       {' in the GNS3 Documentation'}
                                    </Text>
                                 </View>
                              )}
                           </View>
                        </GridCell>
                        <GridCell>
                           <View
                              width="100%"
                              padding="20px[a-d] 30px[e-f]"
                              backgroundColor="#fff"
                              borderRadius="5px"
                              minHeight="200px[a-c] 400px[d-f]"
                              border="1px solid #eee">
                              <Text size="3[a-d] 4[e-f]" weight="medium">
                                 GNS3 Community Results
                              </Text>
                              <Spacer size="1" />
                              {loading && (
                                 <View width="100%" padding="30px" textAlign="center">
                                    <Text
                                       size="2.5"
                                       color="#333"
                                       weight="medium"
                                       style={{
                                          display: 'inline-block'
                                       }}>
                                          Searching...
                                    </Text>
                                 </View>
                              )}
                              {!loading && activeSearchValue &&
                              searchResults.items.length === 0 && (
                                 <View width="100%" padding="30px" textAlign="center">
                                    <Text size="2.5" color="#888">
                                       {'There were no results found for '}
                                       <Text
                                          size="2.5"
                                          color="#333"
                                          weight="medium"
                                          style={{
                                             display: 'inline-block'
                                          }}>
                                          {activeSearchValue}
                                       </Text>
                                       {' in the GNS3 community'}
                                    </Text>
                                 </View>
                              )}
                              {activeSearchValue && searchResults.items.length > 0 && (
                                 <View>
                                    <View paddingBottom="50px">
                                       <Text size="2[a-b] 2.5[c-f]" color="#888">
                                          {`Showing ${searchResults.items.length} results for `}
                                          <Text
                                             size="2[a-b] 2.5[c-f]"
                                             color="#333"
                                             weight="medium"
                                             style={{
                                                display: 'inline-block'
                                             }}>
                                             {activeSearchValue}
                                          </Text>
                                       </Text>
                                    </View>
                                    <Grid columns="1" spacing="0px">
                                       {/* eslint-disable-next-line max-len */}
                                       {searchResults.items.map(({ matches, value: initiative }) => (
                                          <GridCell key={initiative.id}>
                                             <Link to={initiativeUrl(initiative)}>
                                                <SearchListItemRow
                                                   dateAdded={initiative.dateAdded}
                                                   matches={matches}
                                                   label={initiative.type.nameSingular}
                                                   numThreadMessages={initiative.thread.numEntries}
                                                   numViews={initiative.numViews}
                                                   summary={initiative.body.summary}
                                                   title={initiative.name}
                                                />
                                             </Link>
                                          </GridCell>
                                       ))}
                                    </Grid>
                                 </View>
                              )}
                           </View>
                        </GridCell>
                     </Grid>
                  </View>
               </View>
            </View>
         </View>
      </View>
   )
}

export default Search
